var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 2.5V3.14706C10.1762 3.14706 12.3529 5.32376 12.3529 8C12.3529 10.6762 10.1762 12.8529 7.5 12.8529C4.82376 12.8529 2.64706 10.6762 2.64706 8C2.64706 6.46971 3.37241 5.04424 4.58824 4.12865V6.38235H5.23529V3.14706H2V3.79412H3.96447C2.72794 4.83395 2 6.36553 2 8C2 11.0328 4.46724 13.5 7.5 13.5C10.5328 13.5 13 11.0328 13 8C13 4.96724 10.5328 2.5 7.5 2.5Z",
    fill: "#0066CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/resetIcon.02aefceab3f7814a24e677f2388fe21a.svg";
export { ForwardRef as ReactComponent };